module.exports = __webpack_public_path__ + "static/logo-90b6227ecb61600c0f9bc643e1c2590b.png";